import { Avatar, Box, Grid, Stack } from '@mui/material'
import { getIsDoctor, hexWithOpacity } from 'common/utils'
import CustomText from 'components/common/CustomText/CustomText'
import { DashboardInvitationItemSkeleton } from 'components/skeletons/DashboardInvitationItemSkeleton'
import DashboardInvitationActionButtons from 'components/tables/ActionButtons/DashboardInvitationActionButtons'
import { useAuth } from 'context/AuthContext'
import { useGetInvitations } from 'hooks/useUsers'
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { useMemo } from 'react'
import { colors } from 'styles/colors'

interface Props {
  item: any,
  refetch?: () => void,
}

const InvitationItem = ({ item, refetch }: Props) => {

  const isDoctor = useMemo(() => {
    return getIsDoctor(item.user_role.name)
  }, [item]);

  return (
    <Stack
      direction={'row'}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        border: `1px solid ${colors.secondary}`,
        borderRadius: '10px',
        padding: '15px',
        gap: 2,
      }}
    >
      {/* Left Section */}
      <Stack
        direction="row"
        alignItems="center"
        flex={1}
      >
        {/* Avatar */}
        <Box
          sx={{
            position: "relative",
            display: "inline-block",
          }}
        >
          <Avatar
            src={item?.user_media?.image?.href_small}
            alt="profile"
            sx={{
              width: 35,
              height: 35,
              bgcolor: colors.avatarBg,
            }}
          />

          <Box
            sx={{
              position: "absolute",
              bottom: -2,
              right: -2,
              width: 14,
              height: 14,
              borderRadius: "50%",
              bgcolor: colors.white,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 5px 12px rgba(0,0,0,0.25)",
            }}
          >
            <DashboardCustomizeIcon sx={{ fontSize: 10, color: colors.link }} />
          </Box>
        </Box>


        <Box ml={1}>
          <CustomText text={`${isDoctor ? 'Dr. ' : ''}${item.name}`} />
        </Box>
      </Stack>

      {/* Right Section (Actions) */}
      <Box>
        <DashboardInvitationActionButtons
          doctorId={item.user_profile[0].user}
          refetch={refetch}
        />
      </Box>
    </Stack>
  )
}


export default function DashboardInvitations() {
  const { user } = useAuth();
  const { data: invitations, refetch, isLoading } = useGetInvitations(user.id);

  const doctors = invitations?.doctors ?? [];

  return (
    <Grid container spacing={1.5} px={2}>
      {isLoading ? (
        <Box></Box>
      ) : doctors.length === 0 ? (
        <Grid size={{ xs: 12 }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="60vh"
            textAlign="center"
            gap={2}
          >
            <DashboardCustomizeIcon
              sx={{ fontSize: 100, color: hexWithOpacity(colors.secondary, 0.5) }}
            />
            <CustomText
              text="No invitations found"
              color={colors.secondary}
            />
          </Box>
        </Grid>
      ) : (
        doctors.map((item: any) => (
          <Grid size={{ xs: 12 }} key={item.id}>
            <InvitationItem item={item} refetch={refetch} />
          </Grid>
        ))
      )}
    </Grid>
  );
}
